import React from 'react'
import classNames from 'classnames'

import { Icon } from '@zambezi/sdk/icons'
import { IsViewport } from '@zambezi/layout-grid'

import { STAFF_PORTAL_HOST } from '../staff'

import style from './Masthead.module.css'

const Masthead = ({
  logout,
  hasError,
  openNavMenu,
  customer,
  authToken,
  isStaffMember,
  brandLogo,
  isLegacyTheme,
}) => {
  const customerName = customer
    ? `${customer.get('firstName')} ${customer.get('lastName')}`
    : ''
  const customerId = customer ? `| Customer ID ${customer.get('cin')}` : ''
  const logoutCallback = isStaffMember
    ? () => alert('Log Out option is disabled for Staff Members')
    : logout
  const Logo = (
    <div
      className={
        isLegacyTheme ? style.legacyBrandContainer : style.brandContainer
      }
    >
      <span
        className={classNames(
          `zb-pull-left js-brand-logo`,
          isLegacyTheme ? style.legacyLogo : style.brandLogo,
          isLegacyTheme
            ? 'zb-masthead-brand-logo'
            : `zb-brand-logo-dark-${brandLogo}`
        )}
      />
    </div>
  )
  return (
    <div>
      {isStaffMember && (
        <div className={classNames(style.staffBar)}>
          <div className={classNames('zb-container', style.staffBarContainer)}>
            <span
              className={classNames(style.staffBarContent, 'js-staff-content')}
            >
              <a
                href={`${STAFF_PORTAL_HOST}/internal-consent#access_token=${authToken}`}
                className={classNames(style.staffLink, 'js-staff-link')}
              >
                <Icon
                  name="chev-left-xsmall"
                  title="Back to customer search."
                  className={style.staffIcon}
                  aria-hidden="true"
                />
                Back to customer search.
              </a>
              You're acting on the customers behalf
            </span>
          </div>
        </div>
      )}
      {hasError ? (
        <header
          className={classNames(
            'zb-masthead-dark-container zb-masthead-container ob-masthead zb-flex-none zb-text-center js-masthead',
            style.headerContainer
          )}
        >
          <div className={classNames('zb-container', style.container)}>
            {Logo}
          </div>
        </header>
      ) : (
        <header
          className={classNames(
            'zb-masthead-dark-container zb-masthead-container ob-masthead zb-flex-none zb-text-center js-masthead',
            style.headerContainer
          )}
        >
          <div className={classNames('zb-container', style.container)}>
            {Logo}
            <IsViewport isMobile isTablet>
              <span className={style.iconContainer}>
                <a
                  className={classNames(style.menuButton, 'js-menu-link')}
                  onClick={openNavMenu}
                >
                  <Icon
                    size="medium"
                    name="more-plain-small"
                    aria-hidden="true"
                  />
                </a>
                <svg className={style.secureIcon}>
                  <use xlinkHref="#ob-padlock-icon" />
                </svg>
              </span>
            </IsViewport>

            <IsViewport isDesktop isWidescreen>
              <span className={style.iconContainer}>
                <span className={style.customerName}>
                  {customerName} {isStaffMember && customerId}
                </span>
                <a
                  tabIndex="0"
                  className={classNames(style.logout, 'js-logOut-link')}
                  onClick={logoutCallback}
                >
                  Log Out
                </a>
                <svg className={style.secureIcon}>
                  <use xlinkHref="#ob-padlock-icon" />
                </svg>
              </span>
            </IsViewport>
          </div>
        </header>
      )}
    </div>
  )
}

export default Masthead
